import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { SwipeAction as AntdMobileSwipeAction } from "antd-mobile";
import { BaseSwipeActionProps, SwipeActionRef } from "./SwipeAction.types";
import "./SwipeAction.scss";

export const SwipeAction = forwardRef<SwipeActionRef, BaseSwipeActionProps>(
  (
    {
      className = "",
      testId,
      children,
      right,
      left,
      rightActions,
      leftActions,
      ...props
    },
    ref
  ) => {
    const swipeActionRef = useRef<any>(null);

    useImperativeHandle(ref, () => ({
      close: () => {
        swipeActionRef.current?.close();
      },
    }));

    const swipeActionClass = ["swipe-action", className]
      .filter(Boolean)
      .join(" ");

    // 转换自定义属性为 antd-mobile 格式
    const convertedProps = {
      ...props,
      right: right || rightActions,
      left: left || leftActions,
    };

    return (
      <AntdMobileSwipeAction
        ref={swipeActionRef}
        className={swipeActionClass}
        data-testid={testId}
        {...convertedProps}
      >
        {children}
      </AntdMobileSwipeAction>
    );
  }
);

SwipeAction.displayName = "SwipeAction";

export default SwipeAction;
